import { render, staticRenderFns } from "./WapMaterielIndex.vue?vue&type=template&id=ac1b17be&scoped=true&"
import script from "./WapMaterielIndex.vue?vue&type=script&lang=js&"
export * from "./WapMaterielIndex.vue?vue&type=script&lang=js&"
import style0 from "./WapMaterielIndex.vue?vue&type=style&index=0&id=ac1b17be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1b17be",
  null
  
)

export default component.exports